import React from 'react'

import clsx from 'clsx'

import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'
import { useAppContext } from 'context/AppContext'
import { useCompareBasket } from 'context/CompareBasketContext'
import { useEventContext } from 'context/EventContext'
import openUrl from 'helpers/openUrl'

import Secondary from '../Secondary'
import ItemCard from './components/ItemCard'

import classes from './Alternatives.module.scss'

/** @type {import('./types').default} */
const Alternatives = ({ children, type, listing, alternatives = [] }) => {
  const compareBasktet = useCompareBasket()
  const alternativeList = [listing].concat(alternatives)
  const compareUrl = compareBasktet.getUrl(alternativeList)
  const { addEvent } = useEventContext({
    engagementComponent: 'contenders',
    engagementDetails: 'button_see-full-comparison',
  })
  const { isCypressTakingSnapshots } = useAppContext()

  const afterProcessing = alternativeList.sort((a, b) => b.rating_rank - a.rating_rank)

  const sendEventCallback = event => {
    event.preventDefault()
    openUrl(compareUrl)
  }

  return (
    <Secondary className="Alternatives" data-testid="alternative-cards">
      <div className={clsx({ [classes.withSticky]: !isCypressTakingSnapshots })}>
        <div className={classes.title}>{children}</div>
        <div className={classes.content}>
          <div className={classes.itemsList}>
            {afterProcessing
              .filter(alternative => listing.id !== alternative.id)
              .map((alternative, i) => (
                <ItemCard type={type} key={alternative.id} listing={alternative} position={i + 1} />
              ))}
          </div>
          <div>
            <CtaButton
              onClick={sendEventCallback}
              className={classes.compareButton}
              fullWidth
              variant="outlined"
              {...addEvent({
                engagementDestination: 'go-to_product_comparisons',
                name: 'engagement_cta_compare',
              })}
            >
              <span className={classes.compareButtonContent}>
                <Icon icon={['ga', 'compare']} size={24} />
                <span>See full comparison</span>
              </span>
            </CtaButton>
          </div>
        </div>
      </div>
    </Secondary>
  )
}

export default Alternatives
